import axios from 'axios'
import { AuthModel, UserModel } from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
/** Admin, Manager, Super Admin, Customer Support — same endpoint */
export const LOGIN_URL = `${API_URL}/auth/useradmin/login/`
export const DEVELOPER_LOGIN_URL = `${API_URL}/auth/useradmin/Spectator/login/`
export const DEVELOPER_PROFILE_URL = `${API_URL}/auth/useradmin/Spectator/profile/`
export const DEVELOPER_PROFILE_UPDATE_URL = `${API_URL}/auth/useradmin/Spectator/profile/update/`
export const DEVELOPER_CHANGE_PASSWORD_URL = `${API_URL}/auth/useradmin/Spectator/change-password/`
export const LOGIN_VERIFY_URL = `${API_URL}/auth/confirm-otp`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post(LOGIN_URL, { email, password })
}

export function developerLogin(email: string, password: string) {
  return axios.post(DEVELOPER_LOGIN_URL, { email, password })
}

export function getDeveloperProfile() {
  return axios.get(DEVELOPER_PROFILE_URL)
}

export function updateDeveloperProfile(data: any) {
  return axios.patch(DEVELOPER_PROFILE_UPDATE_URL, data)
}

export function developerChangePassword(data: any) {
  return axios.post(DEVELOPER_CHANGE_PASSWORD_URL, data)
}

// Server should return AuthModel
export function loginVerify(peid: string, otp: string) {
  return axios.post(LOGIN_VERIFY_URL, { pe_id: peid, otp_code: otp })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    access_token: token,
  })
}
